export default {
  title: {
    history: 'Batch Upload History',
    uploader: 'Batch Upload'
  },
  label: {
    fileName: 'File Name',
    startTime: 'Create Date',
    finishTime: 'Finish Date',
    status: 'Status',
    browserFiles: 'Browse Files',
    job: 'Job',
    source: 'Source Name',
    code: 'Source Tag/Detail',
    comment: 'Comment',
    tag: {
      smart: 'Smart Tags',
      manual: 'Candidate Tags'
    },
    notification: 'Send Notification Email',
    onlyTalentPool: 'Add To Talent Pool Only',
    candidateName: 'Candidate Name',
    email: 'Email',
    phone: 'Mobile',
    result: 'Result',
    duplicateTitle: 'Potential duplicate candidate',
    hrOpenQuestion: 'Recruiter Screen',
    failReason: 'Failure Reason'
  },
  btn: {
    backJobList: 'View Job List',
    backApplicantList: 'Applicant List',
    backTalentPoll: 'Talent Pool',
    backUniversal: 'Candidates',
    viewHistory: 'View Upload History',
    openUploader: 'Batch Upload Candidate',
    startUpload: 'Start Upload',
    viewCandidate: 'View Candidate',
    import: 'Import',
    viewDuplicateCandidate: 'View'
  },
  message: {
    dropTip: 'Drag and drop resume here',
    or: 'Or',
    uploadTip: [
      'You can upload up to 500 resumes at once (single size of no more than 10MB and total size of no more than 500MB)',
      "The acceptable file types include 'pdf', 'doc', 'docx, 'shtml', 'html', 'png', 'jpg', 'jpeg', 'bmp' and 'zip' formats"
    ],
    noSelectedFile: 'no selected any file yet',
    uploadingTip: 'File is uploading, does not close this page',
    uploadedTip: 'File is uploaded, you can close this page safely. Resume will be start process',
    noUploadingFile: 'no any file is uploading',
    leavePageTip: 'Confirm leave this page? File is still uploading!',
    fileCountLimit: 'Only can add {count} files in single upload task',
    fileSizeLimit: 'Single File except size is {size}MB',
    uploadFinished: 'Upload Finished',
    sourceTips: 'Not all users have the authority to create their own source name. If you don\'t see your source name in the drop-down list and are unable to create a new source name, please contact your company AJINGA administrator or email service@ajinga.com.',
    sourcePlaceholder: 'e.g. Job Fair or Hiring Campaign etc.',
    codeTips: 'Not all users have the authority to create their own Source Tag / Detail. If you don\'t see your Source Tag / Detail in the drop-down list and are unable to create a new one, please contact your company AJINGA administrator or email service@ajinga.com.',
    codePlaceholder: 'e.g. Job Fair Date, Campaign Name etc.',
    noCandidate: 'Please select at least one candidate',
    importSuccess: 'Import Success',
    uploadFailed: 'Upload failed'
  },
  containerTitle: {
    uploadHistory: 'Upload History',
    selectedFiles: 'Selected Files',
    uploadStatus: 'Upload Status',
    parseSuccess: 'Successfully Parsed',
    parseFail: 'Parsing Failed'
  },
  taskStatus: {
    FAILED: 'Failed',
    FINISHED: 'Success',
    APPLICATION_EXISTED: 'Duplicate',
    WAITING: 'Processing',
    UPLOADING: 'Uploading',
    NO_CONTACT_INFO: 'No email or mobile for the candidate was provided',
    EXISTED_HR_ACCOUNT: 'The account belongs to a company user ',
    TALENT_EXISTED: 'Duplicate'
  }
}
